import * as React from 'react';
import * as Header from '../constants/Header';
import SignForm from '../containers/SignForm';
import { Icon } from 'element-react';

import '../common/css/reset.css';
import '../common/css/cmn_layout.css';
import '../common/css/cmn_style.css';
import '../css/login.css';

class Description extends React.Component<any, {show: boolean}> {
  constructor (props: any) {
    super(props);
    this.state = {
      show: false
    };
  }

  openDesc () {
    this.setState({
      show: !this.state.show
    });
  }

  render() {
    return (
      <div className="description">
        <style type="text/css">
        {'#wrapper .contentIn { width: 670px; padding: 185px 0 8px; }'}
        {'.contentIn form { background: white; padding: 80px 80px 0; }'}
        {'.description {background: white;}'}
        </style>
        <p className={this.state.show ? 'open-desc' : 'desc-wrap'}>
          <p>ログインできない時は…</p>
          <p>ログインできない原因としては、管理者IDやパスワードを入力にミスがあるのかもしれません。</p>
          <p>&nbsp;</p>
          <p>以下のような要因が考えられます。</p>
          <p>*大文字と小文字が正しく入力されていない</p>
          <p>*全角での入力になってしまっている</p>
          <p>*数字を入力したつもりが、テンキー入力(数字のキーボード)が無効になっている</p>
          <p>*ユーザIDやパスワードにスペースが入力されてしまっている</p>
          <p>&nbsp;</p>
          <p className="arrow-wrap" onClick={_ => this.openDesc()}>
            <Icon name={this.state.show ? 'arrow-up' : 'arrow-down'} />
          </p>
        </p>
      </div>
    );
  }
}

interface LoginProps extends React.Props<{}> {
  headerActions?: any;
}

class Login extends React.Component<LoginProps> {
  constructor (props: any) {
    super(props);
  }

  componentWillMount() {
    document.title = '運動促進';

    this.props.headerActions.setPage(Header.LOGIN);
  }

  render() {
    return ([
      <SignForm key="signForm" />,
      <Description key="desc" />
    ]);
  }
}

export default Login;



// WEBPACK FOOTER //
// ./src/components/Login.tsx